export const gamesData = [
  {
    id: 8,
    title: "Paper Flight",
    slug: "paper-flight",
    gameId: "paper-flight",
    description: "Launch paper planes and see the distance you can travel.",
    thumbnail: "https://bookup-bucket.s3.us-east-1.amazonaws.com/cug-games/plane.png?w=400&h=300&fit=crop",
    badge: "popular",
    plays: 1420,
    likes: 892,
    category: "puzzle",
    subdomain: "paperflight"
  },
  {
    id: 1,
    title: "Brick Builder 3d",
    slug: "brick-builder",
    gameId: "brick-builder",
    description: "Stack blocks and build the tallest tower. How high can you go?",
    thumbnail: "https://bookup-bucket.s3.us-east-1.amazonaws.com/cug-games/brickBuilder+image.png?w=400&h=300&fit=crop",
    badge: "hot",
    plays: 15420,
    likes: 892,
    category: "puzzle",
    subdomain: "brickbuilder"
  },
  {
    id: 2,
    title: "Cug Jump",
    slug: "cug-jump",
    gameId: "cug-jump",
    description: "Race through the cyber city at breakneck speeds. Dodge traffic and collect power-ups!",
    thumbnail: "https://bookup-bucket.s3.us-east-1.amazonaws.com/cug-games/cug+jump.png?w=400&h=300&fit=crop",
    badge: "popular",
    plays: 28340,
    likes: 1563,
    category: "puzzle",
    subdomain: "cugjump"
  },
  {
    id: 3,
    title: "Neon Hades",
    slug: "neon-hades",
    gameId: "neon-hades",
    description: "Protect Earth from alien invasion. Upgrade your ship and save humanity!",
    thumbnail: "https://bookup-bucket.s3.us-east-1.amazonaws.com/cug-games/Neon+Hades.png?w=400&h=300&fit=crop",
    badge: "new",
    plays: 5230,
    likes: 421,
    category: "action",
    subdomain: "neonhades"
  },
  // {
  //   id: 4,
  //   title: "Neon Shadow",
  //   slug: "neon-shadow",
  //   gameId: "neon-shadow",
  //   description: "Challenge your brain with mind-bending puzzles. 500+ levels to conquer!",
  //   thumbnail: "https://bookup-bucket.s3.us-east-1.amazonaws.com/cug-games/neonShadow.png?w=400&h=300&fit=crop&sat=-100&hue=180",
  //   badge: null,
  //   plays: 12890,
  //   likes: 756,
  //   category: "strategy",
  //   subdomain: "puzzlemaster"
  // },
  {
    id: 5,
    title: "React Survial",
    slug: "react-survivors",
    gameId: "react-survivors",
    description: "Hit the beats and feel the music. Sync your moves to epic soundtracks!",
    thumbnail: "https://bookup-bucket.s3.us-east-1.amazonaws.com/cug-games/react+survival.png?w=400&h=300&fit=crop",
    badge: "hot",
    plays: 19750,
    likes: 1122,
    category: "strategy",
    subdomain: "reactsurvivors"
  },
  {
    id: 6,
    title: "CQB School",
    slug: "cqb-school",
    gameId: "cqb-school",
    description: "Build your army and siege enemy towers. Strategic warfare awaits!",
    thumbnail: "https://bookup-bucket.s3.us-east-1.amazonaws.com/cug-games/CQBSchool.png?w=400&h=300&fit=crop",
    badge: "new",
    plays: 8920,
    likes: 634,
    category: "strategy",
    subdomain: "cqbschool"
  },
  {
    id: 7,
    title: "Multiplier",
    slug: "multiplier",
    gameId: "multiplier",
    description: "Combine blocks of the same number to make more room! See the highest score",
    thumbnail: "https://bookup-bucket.s3.us-east-1.amazonaws.com/cug-games/multiplier.png?w=400&h=300&fit=crop",
    badge: "new",
    plays: 8920,
    likes: 634,
    category: "strategy",
    subdomain: "multiplier"
  }
];
